<template>
    <div class="row d-print-none" >
        <div class="col-sm-auto mx-auto ml-sm-auto mr-sm-0" :class="colSizeClass">
            <div class="row" :class="rowClass">
                <div class="col-sm-auto order-3 order-sm-1" v-if="showCancelButton">
                    <button
                        type="button"
                        class="btn btn-outline-main btn-rounded btn-md btn-responsive btn-block z-depth-0"
                        @click.prevent="$emit('cancel')">
                        {{ $t(`${cancelTitleButton}`) }}
                    </button>
                </div>
                <div class="col-sm-auto order-2 order-sm-2 pb-3 pb-sm-0" v-if="hasDefaultSlot">
                    <slot></slot>
                </div>
                <div class="col-sm-auto order-2 order-sm-2 pb-3 pb-sm-0"
                    v-for="(btn, index) in extraButtons"
                    :key="`extra-button-${index}`">
                    <button
                        type="button"
                        class="btn btn-rounded btn-md btn-responsive btn-block z-depth-0"
                        :class="[btn.class ? btn.class : 'btn-outline-main']"
                        @click.prevent="($event)=>btn.fn($event)">
                        {{ btn.title }}
                    </button>
                </div>
                <div class="col-sm-auto order-1 order-sm-3 pb-3 pb-sm-0" v-if="enableButtons">
                    <button
                        type="button"
                        class="btn btn-main btn-rounded btn-md btn-responsive btn-block z-depth-0"
                        @click.prevent="$emit('save')"
                        :disabled="isDisabled">
                        {{ $t(`${submitTitle}`) }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'ManageButtonsFooter',
        props: {
            enableButtons: {
                type: Boolean,
                default: false
            },
            cancelTitle: {
                type: String,
                default: 'global.cancel',
            },
            submitTitle: {
                type: String,
                default: 'global.save',
            },
            backTitle: {
                type: String,
                default: 'global.back',
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            showCancelButton: {
                type: Boolean,
                default: true,
            },
            colSizeClass: {
                type: String,
                default: 'col-12',
            },
            rowClass: {
                type: String,
                default: 'my-3 my-sm-4',
            },
            extraButtons: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                hasDefaultSlot: false,
            }
        },
        computed: {
            // hasDefaultSlot () {
            //     console.log(':', this.$slots[ 'default' ], this.$scopedSlots[ 'default' ]);
            //     return !!this.$slots[ 'default' ] || !!this.$scopedSlots[ 'default' ];
            // },
            cancelTitleButton() {
                return this.enableButtons ? this.cancelTitle : this.backTitle;
            }
        },
        created() {
            this.setShowSlots();
        },
        beforeUpdate() {
            this.setShowSlots();
        },
        methods: {
            setShowSlots() {
                this.hasDefaultSlot = (!!this.$slots[ 'default' ] || !!this.$scopedSlots[ 'default' ]) ? !!this.$slots[ 'default' ] || !!this.$scopedSlots[ 'default' ][0] : false;
            },
        },
    }
</script>
